<template>
  <div class="tournaments">
    <div class="tournaments-filter-header">
      <div class="tournament-label">{{ title }}</div>
      <div
        class="slider-buttons"
        v-if="showSliderButtons">
        <div
          class="button-wrapper"
          @click="slideLeft">
          <div class="scroll-button scroll-left">
            <i class="n-i n-i-arrow-left"/>
          </div>
        </div>
        <div
          class="button-wrapper"
          @click="slideRight">
          <div class="scroll-button scroll-right">
            <i class="n-i n-i-arrow-right"/>
          </div>
        </div>
      </div>
    </div>
    <div class="tournaments-wrapper">
      <div
        class="tournament-item-wrapper"
        @click="selectTournament(null)">
        <div :class="{ active: activeTournament === null, 'tournament-item': true }">
          <div class="tournament-flag-wrapper icon"><i class="n-i n-i-most-popular"/></div>
          <div class="tournament-name">{{ labelAll }}</div>
        </div>
      </div>

      <router-link
        class="tournament-item-wrapper"
        :to="{ name: 'Outrights', params: { sportId }}"
        tag="div"
        @click="selectTournament(null)">
        <div class="tournament-item">
          <div class="tournament-flag-wrapper icon"><i class="n-i n-i-menu-toggle"/></div>
          <div class="tournament-name">{{ getTranslation('sportsbook.outrights_title') }}</div>
        </div>
      </router-link>
      <div
        v-for="tournament in currentTournaments"
        :key="tournament.id"
        @click="selectTournament(tournament)"
        class="tournament-item-wrapper">
        <div
          class="tournament-item"
          :class="{ active: isActiveTournament(tournament) }">
          <div class="tournament-flag-wrapper">
            <div
              class="flag"
              :class="getFlag(tournament)"/>
          </div>
          <div class="tournament-name">
            {{ tournament.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TournamentFilter',
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    currentTournaments() {
      return this.tournaments.slice(this.currentIndex, this.currentIndex + this.itemsPerPage);
    },
    appSettings() {
      return this.$store.getters.getCompanyConfig;
    },
    showSliderButtons() {
      return this.tournaments.length > this.itemsPerPage;
    },
    itemsPerPage() {
      return ((this.appSettings.tournamentFilter.rows * 6) - 2);
    },
    numOfPages() {
      return Math.ceil(this.tournaments.length / this.itemsPerPage);
    },
    activeTournament() {
      return this.$store.getters.getActiveTournament;
    },
    title() {
      return this.getTranslation('sport.tournaments');
    },
    labelAll() {
      return this.getTranslation('main.all');
    },
  },
  props: {
    tournaments: {
      type: Array,
      required: true,
    },
    categories: {
      type: Object,
      required: true,
    },
    sportId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    selectTournament(tournament) {
      this.$store.dispatch('setActiveTournament', tournament);
    },
    slideLeft() {
      if (this.currentIndex <= 0) {
        this.currentIndex = this.itemsPerPage * (this.numOfPages - 1);
        return;
      }
      this.currentIndex -= this.itemsPerPage;
    },
    slideRight() {
      if (this.currentIndex + this.itemsPerPage >= this.tournaments.length) {
        this.currentIndex = 0;
      } else {
        this.currentIndex += this.itemsPerPage;
      }
    },
    getTranslation(key) {
      return this.$store.getters.getTranslation(key) || key;
    },
    getFlag(tournament) {
      return `flag-${_.toLower(this.categories[tournament.idCategory].isoName || 'INT')} flag-${_.toLower(tournament.providerId)}`;
    },
    isActiveTournament(tournament) {
      return this.activeTournament && tournament.id === this.activeTournament.id;
    },
  },
  watch: {
    sportId(newValue) {
      if (newValue) {
        this.currentIndex = 0;
        this.$store.dispatch('setActiveTournament', null);
      }
    },
  },
};
</script>

<style lang="scss">
  @import '../../../scss/default/flags';
  .tournaments {
    background: #242424;
    margin-bottom: 5px;
  }

  .tournaments-wrapper {
    width: 100%;
    overflow: hidden;
  }

  .tournament-item-wrapper {
    width: percentage(100/6/100);
    float: left;
    overflow: hidden;
    height: 100%;
    line-height: 42px;
    padding: 5px;
  }

  .tournament-flag-wrapper {
    height: 32px;
    width: 32px;
    display: block;
    float: left;
    margin: 5px 5px 0 0;
    transform: scale(.75);

    &.icon {
      transform: scale(1.25);
      height: auto;
      line-height: 32px;
      text-align: center;
    }
  }

  .tournament-item {
    background: #424242;
    height: 100%;

    &.active {
      background: #685834;
    }
  }

  .tournament-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 70%;
    font-size: 20px;
  }

  .tournament-label {
    height: 52px;
    line-height: 52px;
    font-size: 24px;
    border-left: 4px solid #0066ae;
    padding: 0 10px;
    font-weight: 300;
    float: left;
    width: 16.6666667%;
  }

  .slider-buttons {
    float: right;
    width: 33.3333334%;

    .button-wrapper {
      width: 50%;
      text-align: center;
      float: left;
      padding: 5px;
      height: 52px;
      line-height: 47px;

      .scroll-button {
        background: rgba(0, 0, 0, 0.3);
        height: 100%;

        &:active {
          background: #353535;
          box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        }
      }
    }
  }

</style>
